function normalizePersonalInfo(profile) {
  if (!profile) return null;

  const personalInfo =
    profile.personalInfo || profile.profile?.personalInfo || null;
  if (!personalInfo) return null;

  return {
    firstName: personalInfo.firstName || "",
    lastName: personalInfo.lastName || "",
    fatherName: personalInfo.fatherName || "",
    idNumber: personalInfo.bookletNumber || personalInfo.idNumber || "",
    nationalCode: personalInfo.nationalCode || "",
    idIssuePlace: personalInfo.placeOfIssue || "",
    birthDate: personalInfo.birthDate || "",
    mobile: personalInfo.mobile || "",
    phone: personalInfo.phone || "",
    address: personalInfo.address || "",
  };
}

export function getProfilePersonalInfo(profile) {
  return normalizePersonalInfo(profile);
}

export function applyProfilePersonalInfo(formData, profile) {
  const personalInfo = normalizePersonalInfo(profile);
  if (!personalInfo) return formData;

  return {
    ...formData,
    ...Object.entries(personalInfo).reduce((acc, [key, value]) => {
      if (!value) return acc;
      const currentValue = formData?.[key];
      if (currentValue === "" || currentValue == null) {
        acc[key] = value;
      }
      return acc;
    }, {}),
  };
}
